import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { AccountLoginInfo } from "src/app/models/User/AccountLoginInfo.model";
import { UsuarioSignIn } from "src/app/models/User/UsuarioSignIn.model";
import { UsuarioSignInResponse } from "src/app/models/User/UsuarioSignInResponse.model";
import { ApiErrorResponse, ApiService, ApiSuccessResponse } from "../api/api.service";
import { SessionService } from "../session/session.service";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    constructor(
        private api: ApiService, 
        private sessionService: SessionService, 
        private route: Router) { }

    public logout(): void {
        this.sessionService.logout();
        window.location.href = "/sign-in";
    }

    public verifyIfIsLogged(): void {
        if (this.sessionService.isLogged) {
            this.route.navigate(["/home"]);
        }
    }

    public async signIn(data: UsuarioSignIn, wizardFinished: boolean = true): Promise<ApiSuccessResponse<UsuarioSignInResponse> | ApiErrorResponse> {
        const r = await this.api.post<UsuarioSignInResponse>('/authentication/sign-in-v2', data);
        if (r.success) {
            this.sessionService.setToken({ token: r.data.token, refreshToken: r.data.refreshToken });
            this.sessionService.setDetails({
                id: r.data.user.id,
                idCompany: r.data.idCompany,
                email: r.data.user.email,
                currency: r.data.user.currency,
                fullName: r.data.user.fullName,
                language: r.data.user.language,
                toursToExecute: [],
                wizardFinished,
                isAdministrator: r.data.isAdministrator,
            });
            return r;
        }
        return r;
    }

    public async getAccountLoginInfo(email: string): Promise<ApiSuccessResponse<AccountLoginInfo> | ApiErrorResponse> {
        return this.api.get<AccountLoginInfo>('/sign-up/account-login-info', { Email: email });
    }

    public async administrativeSignIn(token: string): Promise<boolean> {
        const r = await this.api.post<boolean>('/authentication/admin', {Token: token});
        if (r.success) {
            return true;
        }
        else
            throw r;
    }
}